module.exports = __webpack_public_path__ + "static/media/menu-requests.cfba5e82.svg";